/* eslint-disable react/prop-types */
import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { Button, lighten } from '@mui/material';

const useStyles = makeStyles()((theme) => ({
  success_contained: {
    backgroundColor: theme.palette.success.light,
    color: theme.palette.success.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.success.main,
    },
  },
  success_outlined: {
    border: `1px solid ${lighten(theme.palette.success.main, 0.5)}`,
    color: theme.palette.success.main,
    '&:hover': {
      border: `1px solid ${theme.palette.success.main}`,
      backgroundColor: lighten(theme.palette.success.light, 0.9),
    },
  },

  warning_contained: {
    backgroundColor: theme.palette.warning.light,
    color: theme.palette.warning.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.warning.main,
    },
  },
  warning_outlined: {
    border: `1px solid ${lighten(theme.palette.warning.main, 0.5)}`,
    color: theme.palette.warning.main,
    '&:hover': {
      border: `1px solid ${theme.palette.warning.main}`,
      backgroundColor: lighten(theme.palette.warning.light, 0.9),
    },
  },

  error_contained: {
    backgroundColor: theme.palette.error.light,
    color: theme.palette.error.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.error.main,
    },
  },
  error_outlined: {
    border: `1px solid ${lighten(theme.palette.error.main, 0.5)}`,
    color: theme.palette.error.main,
    '&:hover': {
      border: `1px solid ${theme.palette.error.main}`,
      backgroundColor: lighten(theme.palette.error.light, 0.9),
    },
  },

  info_contained: {
    backgroundColor: theme.palette.info.light,
    color: theme.palette.info.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.info.main,
    },
  },
  info_outlined: {
    border: `1px solid ${lighten(theme.palette.info.main, 0.5)}`,
    color: theme.palette.info.main,
    '&:hover': {
      border: `1px solid ${theme.palette.info.main}`,
      backgroundColor: lighten(theme.palette.info.light, 0.9),
    },
  },

  primary_contained: {
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.primary.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
    },
  },
  primary_outlined: {
    border: `1px solid ${lighten(theme.palette.primary.main, 0.5)}`,
    color: theme.palette.primary.main,
    '&:hover': {
      border: `1px solid ${theme.palette.primary.main}`,
      backgroundColor: lighten(theme.palette.primary.light, 0.9),
    },
  },
}));

// COMPONENT
function ButtonStatus({ children, variant, status, className, ...rest }) {
  const { classes, cx } = useStyles();

  const theStatus = status ?? 'info';
  const theVariant = variant ?? 'outlined';

  return (
    <Button className={cx(classes[`${theStatus}_${theVariant}`], className)} variant={variant} {...rest}>
      {children}
    </Button>
  );
}

export default ButtonStatus;
